import { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Body } from "@vds/typography";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Loader } from "@vds/loaders";
import { Notification } from "@vds/notifications";
import { APPEARANCE_TEXT, CREATE_APPEARANCE, APPEARANCE_RUNTIME_STATUS } from "../../../../constants/enrolledAppearanceConstants";
import { enrollAppearanceRequest, resetEnrollStates } from "../../../../store/actions/ea-actions";

const ProcessingRequiredModal = ({ opened, appearanceId, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const enrollTriggered = useRef(false);
  const { enrolling, enrollError, enrollSuccess } = useSelector((state) => state.enrolledAppearanceReducer);

  useEffect(() => {
    if (enrollSuccess && enrollTriggered.current) {
      enrollTriggered.current = false;
      dispatch(resetEnrollStates());
      onSuccess?.();
    }
  }, [enrollSuccess]);

  useEffect(() => {
    if (enrollError && enrollTriggered.current) {
      enrollTriggered.current = false;
    }
  }, [enrollError]);

  const handleProcessNow = () => {
    enrollTriggered.current = true;
    dispatch(
      enrollAppearanceRequest({
        appearanceId,
        sitesToAdd: [],
        sitesToRemove: [],
        appearanceStatus: APPEARANCE_RUNTIME_STATUS.VALID,
        enrollOnly: false
      })
    );
  };

  const handleClose = () => {
    enrollTriggered.current = false;
    dispatch(resetEnrollStates());
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onOpenedChange={(isOpen) => {
        if (!isOpen) handleClose();
      }}
      disableOutsideClick={true}
      ariaLabel={APPEARANCE_TEXT.PROCESSING_REQUIRED_ARIA_LABEL}
    >
      <ModalTitle>{APPEARANCE_TEXT.PROCESSING_REQUIRED_TITLE}</ModalTitle>
      <ModalBody>
        {enrolling && (
          <div style={{ display: "flex", justifyContent: "center", padding: "12px 0" }}>
            <Loader active={true} fullscreen={false} />
          </div>
        )}
        {enrollError && (
          <div style={{ marginBottom: "12px" }}>
            <Notification
              type="error"
              title={APPEARANCE_TEXT.DEPLOY_TO_COMPANION_ERROR}
              subtitle={enrollError || APPEARANCE_TEXT.PLEASE_TRY_AGAIN}
              disableFocus={false}
            />
          </div>
        )}
        <Body size="large">
          {APPEARANCE_TEXT.PROCESSING_REQUIRED_BODY_BEFORE}
          <i>{APPEARANCE_TEXT.PROCESSING_REQUIRED_BODY_ACTIVE}</i>
          {APPEARANCE_TEXT.PROCESSING_REQUIRED_BODY_AFTER}
        </Body>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            children: APPEARANCE_TEXT.PROCESS_NOW_BUTTON,
            onClick: handleProcessNow,
            disabled: enrolling
          },
          close: {
            children: CREATE_APPEARANCE.CLOSE,
            onClick: handleClose,
            disabled: enrolling
          }
        }}
      />
    </Modal>
  );
};

export default ProcessingRequiredModal;
